<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-skating`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M20 3a2 2 0 012 2v9.999L33.5 15C39.299 15 44 19.701 44 25.5S39.299 36 33.5 36H32v3.999l3.426.001 7.514-4.696 2.12 3.392L36.574 44H4v-4l8-.001V36H4V5a2 2 0 012-2h14zm-4 33v3.999h12V36H16zm-8-6h30.19a6.48 6.48 0 01-4.69 2H8v-2zm10-17H8v13h31.981a6.5 6.5 0 00-6.481-7L18 18.999V13zM8 7h10v2H8V7z"/></svg>
</template>
<script>

export default {
  name: 'IconSkating',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
